var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0083 40.0167C31.0586 40.0167 40.0167 31.0586 40.0167 20.0083C40.0167 8.95803 31.0586 0 20.0083 0C8.95803 0 0 8.95803 0 20.0083C0 31.0586 8.95803 40.0167 20.0083 40.0167Z",
    fill: "url(#paint0_linear_186_612)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04629 19.7918C14.8772 17.2595 18.7589 15.5768 20.7081 14.7605C26.2558 12.4448 27.422 12.045 28.1716 12.0283C28.3382 12.0283 28.7048 12.0616 28.9547 12.2616C29.1546 12.4282 29.2046 12.6447 29.2379 12.8113C29.2712 12.9779 29.3045 13.3278 29.2712 13.5943C28.9713 16.7597 27.6719 24.4398 27.0055 27.9717C26.7223 29.4711 26.1725 29.9708 25.6394 30.0208C24.4732 30.1208 23.5902 29.2545 22.474 28.5214C20.7081 27.3719 19.7252 26.6556 18.0092 25.5227C16.0267 24.2232 17.3095 23.5069 18.4424 22.3407C18.7422 22.0408 23.8568 17.3761 23.9567 16.9596C23.9734 16.9096 23.9734 16.7097 23.8568 16.6097C23.7402 16.5098 23.5736 16.5431 23.4403 16.5764C23.257 16.6097 20.4582 18.4756 15.0105 22.1574C14.2108 22.7072 13.4944 22.9738 12.8447 22.9571C12.1283 22.9404 10.7622 22.5573 9.72933 22.2241C8.47985 21.8242 7.48027 21.6077 7.56357 20.908C7.61355 20.5414 8.11334 20.1749 9.04629 19.7918Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_612",
    x1: 19.9917,
    y1: 0,
    x2: 19.9917,
    y2: 39.7001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.834c6a1cf9d0206a078b1c29823e9797.svg";
export { ForwardRef as ReactComponent };